













import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
const pix: string =
  "https://service-rfwarubo-1251411213.hk.apigw.tencentcs.com/send";
const api: string =
  "https://api.live.bilibili.com/xlive/web-room/v1/index/getInfoByRoom?room_id=";
type axiosPostResult = {
  data: { room_info: { cover: string } };
  status: number;
};
@Component
export default class extends Vue {
  @Prop({ default: 0 }) roomID!: number;
  @Prop({ default: "" }) cover!: string;
  @Prop({ default: "" }) nickname!: string;
  async created() {
    if (this.roomID) {
      const roomID: number = this.roomID;
      let result: axiosPostResult = await axios.post(pix, {
        url: `${api}${roomID}`
      });
      if (
        result &&
        result.data &&
        result.data.room_info &&
        result.data.room_info.cover
      )
        this.cover = result.data.room_info.cover;
    } else {
    }
  }
  get url() {
    return `https://live.bilibili.com/${this.roomID}`;
  }
}
